












































import {
  defineComponent, PropType, Ref, ref, watch,
} from '@vue/composition-api';

import { ID } from '@/types';

interface ModelValue { pickup: ID; sixWheels: ID; tenWheels: ID; trailer: ID }

const VehicleForm = defineComponent({
  props: {
    title: {
      type: String,
    },
    value: {
      type: Object as PropType<ModelValue>,
      default: () => ({
        pickup: '',
        sixWheels: '',
        tenWheels: '',
        trailer: '',
      }),
    },
    placeholder: { type: String },
    type: { type: String },
    min: {},
    rules: {},
  },
  setup(props, { emit }) {
    const internalValue: Ref<ModelValue> = ref({
      pickup: '',
      sixWheels: '',
      tenWheels: '',
      trailer: '',
    });

    watch(() => props.value, (newVal: ModelValue, oldVal: ModelValue) => {
      if (newVal !== oldVal) internalValue.value = newVal;
    });

    function updateValue(key: string, $event: ID) {
      emit('input', {
        ...props.value,
        [key]: $event,
      });
    }

    return {
      internalValue,
      updateValue,
    };
  },
});

export default VehicleForm;
